const TimeAndLocation = ({weather : {formattedLocalTime, name, country}}) => {
    return (
        <div>
            <div className="flex items-center justify-center my-6">
                <p className=" font-extralight">
                    {formattedLocalTime}
                </p>
            </div>
            <div className="flex items-center justify-center my-3">
                <p className="text-xl font-medium">
                    {`${name}, ${country}`}
                </p>
            </div>
        </div>
    )
}

export default TimeAndLocation